import { render } from "./on-air.vue?vue&type=template&id=d31a96d8&scoped=true"
const script = {}

import "./on-air.vue?vue&type=style&index=0&id=d31a96d8&scoped=true&lang=scss"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d31a96d8"]])

export default __exports__